import useOrderInformationHook from "@/shared/hooks/useOrderInformationHook";
import { PaymentMethodEnum, PaymentStatusEnum } from "@/shared/utils/enum";
import { formatPrice } from "@/shared/utils/helpers";
import { OrderV2 } from "@/shared/v2/queries/interfacesV2";
import { useTranslation } from "react-i18next";
import Spinner from "../Spinner/Spinner";
import Tooltip from "@/Components/Tooltip/Tooltip";
import { cn } from "@/shared/utils/cn";

const OrderCardPrice = ({ order }: { order: OrderV2 }) => {
  const { t } = useTranslation();
  const {
    total_price,
    total_paid,
    payment_method_id,
    order_session_id,
    order_payment_status,
    table_number,
  } = useOrderInformationHook(order);
  const totalPrice = parseFloat(total_price);
  const totalPaid = parseFloat(total_paid);

  const showPendingPaymentSpinner =
    order_session_id === undefined &&
    (order_payment_status === PaymentStatusEnum.PENDING_PAYMENT ||
      payment_method_id === PaymentMethodEnum.PAYMENT_METHOD_NOT_KNOWN_YET);

  return (
    <div className="flex flew-row gap-1 flex-wrap">
      <div
        className={cn(
          "flex gap-2 whitespace-nowrap rounded px-[6px] py-1 font-bold bg-grey-blue-light"
        )}
      >
        {table_number ? (
          `${t("table")} ${table_number}`
        ) : (
          <>
            {formatPrice(totalPrice)}
            {showPendingPaymentSpinner && (
              <Tooltip content={<>{t("paymentIsPending")}</>}>
                <div>
                  <Spinner size="0.17rem" />
                </div>
              </Tooltip>
            )}
          </>
        )}
      </div>
      {Boolean(totalPaid) && totalPrice !== totalPaid && (
        <div
          className={cn(
            "whitespace-nowrap rounded px-[6px] py-1 font-bold",
            totalPaid > totalPrice ? "bg-error" : "bg-success"
          )}
        >
          {formatPrice(totalPrice - totalPaid)}
        </div>
      )}
    </div>
  );
};

export default OrderCardPrice;
